import template from "./bCalendarWidget.html";
import moment from "moment";

export function bCalendarWidgetDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: bCalendarWidgetController,
    controllerAs: 'bCalendarWidget',
    bindToController: true,
    scope: {
      highlightedDates: "=",
      onClickDate: "="
    }
  };

  return directive;
}

const dateToRFC3339 = (year, month, day) => {
  const monthS = month < 10 ? `0${month}` : `${month}`;
  const dayS = day < 10 ? `0${day}` : `${day}`;
  return `${year}-${monthS}-${dayS}T12:00:00.000000`;
};

class bCalendarWidgetController {
  constructor ($scope) {
    'ngInject';
    this.$scope = $scope;
    this.init();
  }

  init() {
    this.date = moment();
    this.days = [];
    this.dayNames = [];
    this.generateDayNames();

    this.$scope.$watch(() => this.highlightedDates, () => this.generateCalendar(), true);
  }

  setCorrectMonthForNavigation(onlyNavigation) {
    if(onlyNavigation === undefined && this.highlightedDates)
    {
      this.date.set('month', this.highlightedDates[3].date.month());
    }
  } 

  generateCalendar(onlyNavigation) {

    this.setCorrectMonthForNavigation(onlyNavigation);

    var lastDayOfMonth = this.date.endOf('month').date(),
      month = this.date.month() + 1,
      year = this.date.year(),
      n = 1;
    var firstWeekDay = this.firstWeekDaySunday === true ? this.date.set('date', 2).day() : this.date.set('date', 1).day();
    if (firstWeekDay !== 1) {
      n -= firstWeekDay - 1;
    }
    if(n==2) n = -5;
    this.dateValue = this.date.format('MMMM YYYY');
    this.days = [];
    const todayString = moment().format("YYYY-MM-DD");
    for (var i = n; i <= lastDayOfMonth; i += 1) {
      if (i > 0) {
        const date = moment(dateToRFC3339(year, month, i));
        const dateString = date.format("YYYY-MM-DD");
        const highlighted = !!(this.highlightedDates || [])
          .map((x)=> x.date)
          .find((x) => {
            return x.format("YYYY-MM-DD") == dateString;
          });

        const today = todayString == dateString;
        this.days.push({today, highlighted, date: dateString, day: i, month: month, year: year, enabled: true});
      } else {
        this.days.push({day: null, month: null, year: null, enabled: false});
      }
    }
  }

  generateDayNames () {
    var tempDate = this.firstWeekDaySunday === true ? moment(dateToRFC3339(2015,6,7)) : moment(dateToRFC3339(2015,6,1));
    for (var i = 0; i < 7; i += 1) {
      this.dayNames.push(tempDate.format('ddd'));
      tempDate.add('1', 'd');
    }
  }

  selectDate (e, date) {
    if(this.onClickDate) this.onClickDate(e, date.date);
  }

  prevYear() {
      this.date.subtract(1, 'Y');
      this.generateCalendar(true);
  }

  prevMonth() {
      this.date.subtract(1, 'M');
      this.generateCalendar(true);
  }

  nextMonth() {
      this.date.add(1, 'M');
      this.generateCalendar(true);
  }

  nextYear() {
      this.date.add(1, 'Y');
      this.generateCalendar(true);
  }
}
